/* Local-storage helpers for remembering the active faculty course workspace. */

const FACULTY_WORKSPACE_KEY = "faculty-workspace-course";

export function getFacultyWorkspaceCourse() {
  // Guard against SSR/tests where `window` is not defined.
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(FACULTY_WORKSPACE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.courseId) {
      return null;
    }
    return parsed;
  } catch (_error) {
    return null;
  }
}

export function setFacultyWorkspaceCourse(course) {
  // Invalid input clears the remembered workspace instead of storing junk.
  if (typeof window === "undefined") {
    return;
  }

  if (!course?.courseId) {
    window.localStorage.removeItem(FACULTY_WORKSPACE_KEY);
    return;
  }

  window.localStorage.setItem(
    FACULTY_WORKSPACE_KEY,
    JSON.stringify({
      courseId: course.courseId,
      name: course.name || "",
    })
  );
}

export function formatFacultyWorkspaceCourse(course) {
  // Shared display formatting keeps the faculty shell consistent.
  if (!course?.courseId) {
    return "No course selected yet";
  }
  return course.name ? `${course.courseId} — ${course.name}` : course.courseId;
}
